import script from "./IconButtonBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./IconButtonBackground.vue?vue&type=script&setup=true&lang=js"

import "./IconButtonBackground.vue?vue&type=style&index=0&id=20adabe7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.5.17_webpack@5.69.1_uglify-js@3.15.2_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20adabe7"]])

export default __exports__